import { call, getContext } from 'redux-saga/effects';
import { MaybeWorker } from '../MaybeWorker';
function sagaRequest(apiProvider, ...params) {
  const callEffect = call(function* () {
    const apiContext = yield getContext('api');
    const api = apiContext && apiProvider(apiContext) || apiProvider;
    return yield call(api, ...params);
  });
  return new MaybeWorker(callEffect);
}
export default sagaRequest;